import { UnitOfMeasureEnum } from "../../../api/Representation";
import { VehicleTypeCategoryEnum } from "../../vehicleTypes/api/Representation";
import { FulfillmentMethodEnum, ProductPricingMethodEnum } from "../../orders/api/Representation";
export var RelationshipTypeEnum;
(function (RelationshipTypeEnum) {
    RelationshipTypeEnum["CONTRACTOR"] = "CONTRACTOR";
    RelationshipTypeEnum["CARRIER"] = "CARRIER";
    RelationshipTypeEnum["CUSTOMER"] = "CUSTOMER";
})(RelationshipTypeEnum || (RelationshipTypeEnum = {}));
export var InsuranceCategoryEnum;
(function (InsuranceCategoryEnum) {
    InsuranceCategoryEnum["MOTOR_VEHICLE"] = "MOTOR_VEHICLE";
    InsuranceCategoryEnum["PUBLIC_LIABILITY"] = "PUBLIC_LIABILITY";
    InsuranceCategoryEnum["WORK_COVER"] = "WORK_COVER";
    InsuranceCategoryEnum["IN_TRANSIT"] = "IN_TRANSIT";
})(InsuranceCategoryEnum || (InsuranceCategoryEnum = {}));
export var DMSBillingTypeEnum;
(function (DMSBillingTypeEnum) {
    DMSBillingTypeEnum["PREPAID_CREDIT"] = "PREPAID_CREDIT";
    DMSBillingTypeEnum["CONTRACT"] = "CONTRACT";
})(DMSBillingTypeEnum || (DMSBillingTypeEnum = {}));
export var MarketplaceBillingEnum;
(function (MarketplaceBillingEnum) {
    MarketplaceBillingEnum["ON_ACCOUNT"] = "ON_ACCOUNT";
    MarketplaceBillingEnum["PAY_AS_YOU_GO"] = "PAY_AS_YOU_GO";
})(MarketplaceBillingEnum || (MarketplaceBillingEnum = {}));
export var MarketplaceBillingInvoiceFrequencyEnum;
(function (MarketplaceBillingInvoiceFrequencyEnum) {
    MarketplaceBillingInvoiceFrequencyEnum["DAILY"] = "DAILY";
    MarketplaceBillingInvoiceFrequencyEnum["WEEKLY"] = "WEEKLY";
    MarketplaceBillingInvoiceFrequencyEnum["MONTHLY_INVOICED_WEEKLY"] = "MONTHLY_INVOICED_WEEKLY";
    MarketplaceBillingInvoiceFrequencyEnum["MONTHLY"] = "MONTHLY";
})(MarketplaceBillingInvoiceFrequencyEnum || (MarketplaceBillingInvoiceFrequencyEnum = {}));
export var DeliveryModelEnum;
(function (DeliveryModelEnum) {
    DeliveryModelEnum["LAST_MILE_DELIVERY"] = "LAST_MILE_DELIVERY";
    DeliveryModelEnum["PICKUP_AND_DROP"] = "PICKUP_AND_DROP";
    DeliveryModelEnum["TRANSFER_TO_DC"] = "TRANSFER_TO_DC";
})(DeliveryModelEnum || (DeliveryModelEnum = {}));
export var SettlementPeriodEnum;
(function (SettlementPeriodEnum) {
    SettlementPeriodEnum["WEEKLY"] = "WEEKLY";
    SettlementPeriodEnum["FORTNIGHTLY"] = "FORTNIGHTLY";
    SettlementPeriodEnum["TRI_WEEKLY"] = "TRI_WEEKLY";
    SettlementPeriodEnum["FOUR_WEEKLY"] = "FOUR_WEEKLY";
})(SettlementPeriodEnum || (SettlementPeriodEnum = {}));
export var InvoiceTermsEnum;
(function (InvoiceTermsEnum) {
    InvoiceTermsEnum["SEVEN_DAYS"] = "SEVEN_DAYS";
    InvoiceTermsEnum["FOURTEEN_DAYS"] = "FOURTEEN_DAYS";
    InvoiceTermsEnum["THIRTY_DAYS"] = "THIRTY_DAYS";
    InvoiceTermsEnum["LAST_DAY_OF_MONTH"] = "LAST_DAY_OF_MONTH";
    InvoiceTermsEnum["LAST_DAY_OF_NEXT_MONTH"] = "LAST_DAY_OF_NEXT_MONTH";
    InvoiceTermsEnum["LAST_DAY_OF_MONTH_PLUS_TWO_MONTHS"] = "LAST_DAY_OF_MONTH_PLUS_TWO_MONTHS";
})(InvoiceTermsEnum || (InvoiceTermsEnum = {}));
export var SalesOrderShowQtyAndTotalsEnum;
(function (SalesOrderShowQtyAndTotalsEnum) {
    SalesOrderShowQtyAndTotalsEnum["NEVER"] = "NEVER";
    SalesOrderShowQtyAndTotalsEnum["ALWAYS"] = "ALWAYS";
    SalesOrderShowQtyAndTotalsEnum["AUTO"] = "AUTO";
})(SalesOrderShowQtyAndTotalsEnum || (SalesOrderShowQtyAndTotalsEnum = {}));
export var SenderReceiverProductCatalogueStatusEnum;
(function (SenderReceiverProductCatalogueStatusEnum) {
    SenderReceiverProductCatalogueStatusEnum["DISABLED"] = "DISABLED";
    SenderReceiverProductCatalogueStatusEnum["ENABLED"] = "ENABLED";
    SenderReceiverProductCatalogueStatusEnum["ENFORCED"] = "ENFORCED";
})(SenderReceiverProductCatalogueStatusEnum || (SenderReceiverProductCatalogueStatusEnum = {}));
export var EmployeeDriverLicenseComplianceEnum;
(function (EmployeeDriverLicenseComplianceEnum) {
    EmployeeDriverLicenseComplianceEnum["NONE"] = "NONE";
    EmployeeDriverLicenseComplianceEnum["OPTIONAL"] = " OPTIONAL";
    EmployeeDriverLicenseComplianceEnum["MANDATORY"] = "MANDATORY";
})(EmployeeDriverLicenseComplianceEnum || (EmployeeDriverLicenseComplianceEnum = {}));
export var CreditTransactionTypeEnum;
(function (CreditTransactionTypeEnum) {
    CreditTransactionTypeEnum["PURCHASE"] = "PURCHASE";
    CreditTransactionTypeEnum["USAGE"] = "USAGE";
    CreditTransactionTypeEnum["TRIAL"] = "TRIAL";
    CreditTransactionTypeEnum["BONUS"] = "BONUS";
})(CreditTransactionTypeEnum || (CreditTransactionTypeEnum = {}));
export var RetailExpressDeliveryInstructionsFrom;
(function (RetailExpressDeliveryInstructionsFrom) {
    RetailExpressDeliveryInstructionsFrom["PUBLIC_COMMENTS"] = "PUBLIC_COMMENTS";
    RetailExpressDeliveryInstructionsFrom["PRIVATE_COMMENTS"] = "PRIVATE_COMMENTS";
})(RetailExpressDeliveryInstructionsFrom || (RetailExpressDeliveryInstructionsFrom = {}));
export var RegistrationChannelEnum;
(function (RegistrationChannelEnum) {
    RegistrationChannelEnum["MARKETPLACE"] = "MARKETPLACE";
    RegistrationChannelEnum["DMS"] = "DMS";
    RegistrationChannelEnum["CONTRACTOR"] = "CONTRACTOR";
})(RegistrationChannelEnum || (RegistrationChannelEnum = {}));
export var TenantFeeCalculationMethodEnum;
(function (TenantFeeCalculationMethodEnum) {
    TenantFeeCalculationMethodEnum["FIXED_AMOUNT"] = "FIXED_AMOUNT";
    TenantFeeCalculationMethodEnum["PER_UOM"] = "PER_UOM";
    TenantFeeCalculationMethodEnum["PERCENT_PER_UOM"] = "PERCENT_PER_UOM";
})(TenantFeeCalculationMethodEnum || (TenantFeeCalculationMethodEnum = {}));
export var AdvisoryCodeEnum;
(function (AdvisoryCodeEnum) {
    AdvisoryCodeEnum["DRIVER_LICENSE_EXPIRY"] = "DRIVER_LICENSE_EXPIRY";
    AdvisoryCodeEnum["VEHICLE_REGISTRATION_EXPIRY"] = "VEHICLE_REGISTRATION_EXPIRY";
    AdvisoryCodeEnum["INSURANCE_POLICY_EXPIRY"] = "INSURANCE_POLICY_EXPIRY";
    AdvisoryCodeEnum["VEHICLE_CHECK_FAILED"] = "VEHICLE_CHECK_FAILED";
    AdvisoryCodeEnum["LOAD_CHECK_FAILED"] = "LOAD_CHECK_FAILED";
    AdvisoryCodeEnum["DELIVERY_CHECK_FAILED"] = "DELIVERY_CHECK_FAILED";
    AdvisoryCodeEnum["CONTRACTOR_ONBOARDING_CHECK_FAILED"] = "CONTRACTOR_ONBOARDING_CHECK_FAILED";
    AdvisoryCodeEnum["EMPLOYEE_DRIVER_INDUCTION_CHECK_FAILED"] = "EMPLOYEE_DRIVER_INDUCTION_CHECK_FAILED";
    AdvisoryCodeEnum["DRIVER_FATIGUE_BREACH"] = "DRIVER_FATIGUE_BREACH";
    AdvisoryCodeEnum["DRIVER_IDLE"] = "DRIVER_IDLE";
    AdvisoryCodeEnum["CONSIGNMENT_POD"] = "CONSIGNMENT_POD";
    AdvisoryCodeEnum["CONSIGNMENT_DUE"] = "CONSIGNMENT_DUE";
    AdvisoryCodeEnum["CONSIGNMENT_DRIVER_UNASSIGNED"] = "CONSIGNMENT_DRIVER_UNASSIGNED";
    AdvisoryCodeEnum["VEHICLE_HIRE_ACCEPTED"] = "VEHICLE_HIRE_ACCEPTED";
    AdvisoryCodeEnum["VEHICLE_HIRE_DEALLOCATED"] = "VEHICLE_HIRE_DEALLOCATED";
    AdvisoryCodeEnum["VEHICLE_HIRE_DOCKET"] = "VEHICLE_HIRE_DOCKET";
    AdvisoryCodeEnum["VEHICLE_HIRE_NOT_STARTED"] = "VEHICLE_HIRE_NOT_STARTED";
    AdvisoryCodeEnum["VEHICLE_HIRE_TEMPLATE_SCHEDULE_FAILURES"] = "VEHICLE_HIRE_TEMPLATE_SCHEDULE_FAILURES";
    AdvisoryCodeEnum["MARKETPLACE_CONSIGNMENT_ACCEPTED"] = "MARKETPLACE_CONSIGNMENT_ACCEPTED";
})(AdvisoryCodeEnum || (AdvisoryCodeEnum = {}));
